import { withStyles } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import Placeholder from '@material-ui/lab/Skeleton'

const styles = theme => ({
  root: {
    background: props =>
      props.light
        ? fade(`var(--gameday-body-background, ${theme.body.background})`, 0.3)
        : `var(--gameday-body-background, ${theme.body.background})`,
    '&:empty:before': {
      opacity: 0,
    },
  },
})

const Skeleton = ({ classes, light, ...rest }) => {
  return <Placeholder classes={{ root: classes.root }} {...rest} />
}

const SkeletonComponent = withStyles(styles)(Skeleton)
SkeletonComponent.displayName = 'Skeleton'
export default SkeletonComponent
